
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { message, Tooltip, Button, Typography } from "antd";
import { LeftOutlined } from '@ant-design/icons';
import { ContextAPI } from '../../../../ContextAPI';

import { platformApi } from '../../../../api';
import WrappedInvoiceForm from './InvoiceForm';

const JobInvoice = (props) => {
  const { redirect } = props;
  const { loginCredintials } = useContext(ContextAPI);
  const isCEO = loginCredintials?.role === 'CEO';
  const modifyAccess = loginCredintials?.roleAccess?.some(
    (each) => each.subModule === 'job_invoice' && each.access?.update
  ) ?? false;

  const { Title } = Typography;
  const [customer, setCustomer] = useState([]);
  const [partsData, setPartsData] = useState([]);
  const [editable, setEditable] = useState(false);
  const [editData, setEditData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [searchSupply, setSearchSupply] = useState();
  const [partSearch, setPartSearch] = useState(false);
  const [modifyType, setModifyType] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const [jobNo, setJobNo] = useState([]);
  const [jobCode, setJobCode] = useState([]);
  const [initialData, setInitialData] = useState({})
  const [formType, setFormType] = useState("ADD")
  let url = location.pathname;
  let id = url.substring(url.lastIndexOf('/') + 1);

  useEffect(() => {
    const formType = id === ":id" ? "ADD" : "MODIFY"
    setFormType(formType)
    if (id != ':id') {
      platformApi
        .get(`/api/saleSpareInvoice/${id}`)
        .then((res) => {
          const { data } = res;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              setInitialData(response.data)
            } else {
              console.error("Unable to fetch Sale Spare Item");
            }
          } else {
            console.error("Unable to fetch Sale Spare Item");
          }
        })
        .catch((error) => {
          // setSpinning(false);
          console.error("Unable to fetch Sale Spare Item", error);
        });
      if (location.state && location.state.editable) {
        setEditable(false)
      }
      else {
        setEditable(true);
      }
      // setEditable(true);
    }
    else {
      setEditable(false);
    }
    getCustomerData();
    getPartsDetails();
    getJobCodes();
    getJobNo();
    getSelectedSpareInvoice();
  }, [id]);

  useEffect(() => {
    if (search) {
      getPartsDetailOnSearch(search);
    }
    else {
      getPartsDetails();
    }
  }, [search]);

  const getCustomerData = () => {
    platformApi
      .post('/api/customer/get', { page: page, size: limit, searchString: searchSupply })
      .then((res) => {
        let { data } = res
        if (data && data.code === 200) {
          let { response } = data;
          if (response && response.code === 200 && response.data && response.data.customer) {
            let activeCustomer = response.data.customer
            setCustomer(activeCustomer)
          }
        } else {
          message.error('Cannot fetch Customer Data');
        }

        //setTableLoading(false);
      })
      .catch((err) => {
        console.error('Customer fetch error', err);
        message.error('Cannot fetch Customer Data');
        //setTableLoading(false);
      });
  }

  const getPartsDetails = () => {
    platformApi
      .post(`/api/sparesInventory/branch/get/`, {
        page: page,
        size: 10,
        searchString: ''
      })
      .then((res) => {
        //setSpinning(false);
        const { data } = res;
        if (data && data.code === 200) {
          const { response } = data;
          if (response && response.code === 200 && Array.isArray(response.data)) {
            // console.log("response",response.data)
            let parts = [];
            for (let item of response.data) {
              if (item && item.partNo) {
                let unitRate = 0
                item.transactions && item.transactions.sparesPurchase && item.transactions.sparesPurchase.map(item2 => {
                  item2.purchaseItemInvoice && item2.purchaseItemInvoice.map(item3 => {
                    if (item.partNo && item3.partNumber && item.partNo.id === item3.partNumber.id) {
                      unitRate += item3.unitRate || 0
                    }
                  })
                })
                item.partNo.unitRate = unitRate
                parts.push(item.partNo)
              }
            }
            setPartsData([]);
          }
        }
        else {
          message.error("Unable to fetch Parts", 2);
        }
      })
      .catch((error) => {
        console.error("Error on Parts Master : ", error);
        // setSpinning(false);
        message.error("Unable to fetch Parts", 2);
      });
  }

  const getPartsDetailOnSearch = async (search) => {
    await platformApi
      .post("/api/jobInvoice/search", {
        search
      })
      .then((res) => {
        const { data } = res;
        if (data && data.code === 200) {
          const { response } = data;
          if (response && response.code === 200) {
            console.log("search", response.data.sparesInventory)
            // setPartsData(response.data.sparesInventory);
          }
        } else {
          // message.error("Unable to fetch Parts", 2);
        }
      })
      .catch((error) => {
        console.error("Error on Parts Master : ", error);
        // setSpinning(false);
        // message.error("Unable to fetch Parts", 2);
      });

  }

  const getJobCodes = () => {
    platformApi
      .post("/api/jobCode/getJobCodes", {
        size: 10,
        page: 1,
      })
      .then((res) => {
        let { data } = res;
        if (data && data.code === 200) {
          let { response } = data;
          if (response && response.code === 200) {
            setJobCode(response.data);
          } else {
            message.error("Failed to fetch JobCodes");
          }
        }
        else {
          message.error("Failed to fetch JobCodes");
        }
      })
      .catch((error) => {
        console.error("Error on JobCodes : ", error);
        message.error("Failed to fetch JobCodes");
      });
  }


  const getJobNo = (searchJobNo = "") => {
    platformApi
      .post("/api/options/get/", {
        module: "jobOrders",
        column: "jobNo",
        searchString: searchJobNo,
        size: 10,
        page: 1,
        except: ["Gate Pass", "Payment Received", "Invoice", "Proforma Invoice", "PAID"],
        mechanicAssigned: true
      })
      .then((res) => {
        setJobNo(res.data.response)
      });
  };

  const getSelectedSpareInvoice = () => {
    if (id !== ':id') {
      platformApi
        .get(`/api/jobInvoice/${id}`)
        .then((res) => {
          //setSpinning(false);
          const { data } = res;
          if (data && data.code === 200) {
            const { response } = data;
            if (response && response.code === 200) {
              setEditData(response.data)
            } else {
              message.error("Unable to fetch Sale Job Item", 2);
            }
          } else {
            message.error("Unable to fetch Sale Job Item", 2);
          }
        })
        .catch((error) => {
          console.error("Error on Sale Job Item : ", error);
          // setSpinning(false);
          message.error("Unable to fetch Sale Job Item", 2);
        });
    }
  }

  return (
    <>
      <Title level={4}>
        <Tooltip placement="topLeft" title={"Back"}>
          <Button
            style={{ marginRight: '1rem' }}
            onClick={() => history.push('/autoadmin/job_invoice')}
          >
            <LeftOutlined />
          </Button>
        </Tooltip>
        Job Invoice
      </Title>
      <WrappedInvoiceForm
        customer={customer}
        invoiceId={id}
        setValidCustomer={setCustomer}
        partsData={partsData}
        setPartsData={setPartsData}
        editable={editable}
        modifyType={modifyType}
        id={id}
        formType={formType}
        setSearch={setSearch}
        onEdit={(editable) => {
          setEditable(editable)
          setModifyType(!editable)
        }}
        editData={editData}
        setPartSearch={setPartSearch}
        jobNo={jobNo}
        setJobNo={setJobNo}
        setJobCode={setJobCode}
        jobCode={jobCode}
        initialData={initialData}
        isCEO={isCEO}
        modifyAccess={modifyAccess}
      />
    </>
  )
}

export default JobInvoice